'use strict';
import moment from 'moment'


export default function(angularModule) {
  angularModule.controller('CampaignsCtrl', function($scope, $q, $state, user, $location, $uibModal, accountsService, campaignManagerService, pagingService, updateService, adminSearchService, stringService, confirmService, userManagerService, RGSenderConfigService, RGSendingStatsService, userService, $log, reactContainer){
    var vm = this;

    //Unset campaignId
    accountsService.retrieveCurrentAccountInfo().then(function(accountInfo) {
      vm.accountInfo = accountInfo
    })
    vm.campaignSearchQuery = adminSearchService.getSearchQuery();
    vm.freshQuery = null;
    vm.accountSelected = false;
    vm.totalCampaignsInResponse = null;
    vm.state = {
      loading : true,
      updating: false
    };
    vm.campaignExportConfig = {};

    vm.pageStrings = stringService.adminStrings();
    vm.updateDetails = updateService.getUpdateDetails();

    vm.accountConfig = {
      required : false,
      accountId : null,
      disableDropdown: false,
      showAccountSelection: false
    };

    vm.userType = user.userType

    vm.userMap = {};

    vm.timeSpan = "All Time"

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    };

    vm.reportRanges = [
      {
        id: 'MTD',
        name: "Month to Date"
      },
      {
        id: 'LastMonth',
        name: "Last Month"
      },
      {
        id: 'QTD',
        name: "Calendar Quarter to Date"
      },
      {
        id: 'AllTime',
        name: "All Time"
      },
      {
        id: 'SpecificDates',
        name: "Selected Dates"
      }
    ];
    vm.searchConfig = {
      range: vm.reportRanges[0],
      startDate: null,
      endDate: null,
    };

    vm.openMessageQuoteWarningModal = function() {
      const modal = $uibModal.open({
        template: require('./messageQuotaWarningConfigModal.html'),
        controller: 'MessageQuotaWarningConfigModalController'
      })
      modal.closed.then(function() {
        RGSenderConfigService.getConfig().then(function(config) {
          vm.warningThreshold = config.messageQuotaWarningConfig.warningThreshold
        })
      })
    }

    vm.openConfirmDeleteCampaignModal = function (campaign) {
      vm.campaign = angular.copy(campaign);
      $('#confirmDeleteCampaignModal').modal();
    };

    vm.generateEmbedCode = function(campaign) {
      $uibModal.open({
        controller: ["$scope",function($scope)
          {
            $scope.campaignId = campaign._id.$oid;
            $scope.widgetId = campaign.formId;
            $scope.campaignGroupId = campaign.groupId;
          }
        ],
        template: require('../widgets/widgetEmbedModal.html')  // this is an embedded template in widgets.html
      })
    };

    vm.toggleActive = function(campaign){
      campaign.isActive = !campaign.isActive;
      campaignManagerService.saveCampaign(campaign).then(
        function(response) {
          processActivation(response)
        }
        ).catch(handleError);
    };

    function handleError(resp){
    }

    vm.refreshCampaigns = refreshCampaigns;
    function refreshCampaigns() {
      vm.state.loading = true;
      vm.campaignSearchQuery = adminSearchService.getSearchQuery();
      vm.freshQuery = vm.campaignSearchQuery;
      var accountIdToPass = accountsService.getCurrentAccount().$$state.value;
      vm.accountConfig.accountId = accountIdToPass;

      campaignManagerService.searchCampaigns({searchTextOpt: vm.campaignSearchQuery}).then(response => {
        vm.state.loading = false;
        var campaigns = response.campaigns;
        var campaignIds = campaigns.map(campaign => campaign._id.$oid);

        if (user.permissions.indexOf("UserManagement") >= 0) {
          let missingUserIds = campaigns.map(campaign => campaign.creatorId).filter(id => id != null && typeof vm.userMap[id] === "undefined")
          if (missingUserIds.length > 0) {
            userManagerService.getUsers(_.uniq(missingUserIds))
              .then(userMap => {
                for (let id in userMap) {
                  if (userMap.hasOwnProperty(id)) {
                    vm.userMap[id] = userMap[id]
                  }
                }
              });
          }
        }

        campaignManagerService.getCampaignMeta(campaignIds).then(metaResults => {
          campaigns.forEach(campaign => {
            campaign.meta = metaResults[campaign._id.$oid];
          })
        });

        vm.campaignsPaged = pagingService.createPagingData(campaigns, 15, 'name');
        if(pagingService.getCurrentPage()){
          vm.campaignsPaged.currentPageNum = pagingService.getCurrentPage();
        }

        vm.totalCampaignsInResponse = campaigns.length;

        if(vm.updateConfig.entityId){
          if(_.where(vm.campaignsPaged.pagedItems[0],{id:vm.updateConfig.entityId}).length>0){
            vm.updateConfig.pageOneResult = true;
          }
        }

        var accountIdToPass = vm.accountConfig.accountId == "all" ? undefined : vm.accountConfig.accountId;

        vm.campaignExportConfig = {
          export: function () {
            return angular.noop
          },
          accountId: accountIdToPass,
          campaignSearchQuery: vm.campaignSearchQuery
        };
      });
    }

    vm.getNumberOfDeliveryMethods = function() {
      var filter = {startDate: null, endDate: null}
      if (vm.searchConfig.range.id == 'SpecificDates') {
        if (vm.searchConfig.startDate) {
          filter.startDate = vm.searchConfig.startDate;
        }

        if (vm.searchConfig.endDate) {
          filter.endDate = vm.searchConfig.endDate;
        }
      } else if (vm.searchConfig.range.id == 'MTD') {
        var d = moment().startOf('day').toDate();
        d.setDate(1);

        filter.startDate = d.toJSON();
      } else if (vm.searchConfig.range.id == 'LastMonth') {
        var d = new Date();
        d.setMonth(d.getMonth() - 1);
        d.setDate(1)
        filter.startDate = d.toJSON();
        var endDate = new Date();
        endDate.setDate(0)
        filter.endDate = endDate.toJSON()
      } else if (vm.searchConfig.range.id == 'QTD') {
        var quarter = Math.floor(new Date().getMonth()/4);
        switch(quarter) {
          case 0:
            //This year, January 1st
            filter.startDate = (new Date(new Date().getFullYear(), 0, 1)).toJSON()
            break;
          case 1:
            //This year, April 1st
            filter.startDate = (new Date(new Date().getFullYear(), 3, 1)).toJSON()
            break;
          case 2:
            //This year, July 1st
            filter.startDate = (new Date(new Date().getFullYear(), 6, 1)).toJSON()
            break;
          case 3:
            //This year, October 1st
            filter.startDate = (new Date(new Date().getFullYear(), 9, 1)).toJSON()
            break;
        }
      } else if (vm.searchConfig.range.id == 'AllTime') {
        //No need to set anything
      } else {
        $log.error('Unsupported range type! ' + vm.searchConfig.range.id);
        return;
      }
      if (vm.searchConfig.startDate && vm.searchConfig.endDate && vm.searchConfig.startDate > vm.searchConfig.endDate) {
        $log.error('Start date cannot be after end date!');
        vm.numberOfEmails = 0;
        return;
      }
      if (vm.searchConfig.startDate && vm.searchConfig.startDate > (new Date()).toISOString()) {
        $log.error('Start date cannot be in the future!');
        vm.numberOfEmails = 0;
        return;
      }
      window.filter = filter
      if (!filter.startDate && !filter.endDate) {
        vm.timeSpan = "All Time"
      }
      if (!filter.startDate && filter.endDate) {
        vm.timeSpan = "All Time until " + moment(filter.endDate).toDate().toLocaleDateString()
      }
      if (filter.startDate && !filter.endDate) {
        vm.timeSpan = moment(filter.startDate).toDate().toLocaleDateString() + ' - ' + (new Date()).toLocaleDateString()
      }
      if (filter.startDate && filter.endDate) {
        vm.timeSpan = moment(filter.startDate).toDate().toLocaleDateString() + ' - ' + moment(filter.endDate).toDate().toLocaleDateString()
      }
      if (moment(filter.endDate).isSame(moment(), 'day')) {
        filter.endDate = moment(filter.endDate).add(1, 'd').toDate();
      }

      RGSendingStatsService.getTotalMessagesForMonth().then(response => vm.totalSentForMonth = response.data.messageSentCount)
      RGSendingStatsService.getNumberOfEmailsSent(filter.startDate, filter.endDate).then(response => vm.numberOfEmails = response.data.numberOfEmailsSent)
      RGSendingStatsService.getNumberOfSmssSent(filter.startDate, filter.endDate).then(response => vm.numberOfSms = response.data.numberOfSmsSent)
      RGSenderConfigService.getConfig().then(function(config) {
        vm.warningThreshold = config.messageQuotaWarningConfig.warningThreshold
      })
    }

    vm.canConfigureMessageQuotaWarning = function() {
      let user = userService.getCurrentUser()
      if ((!vm.accountInfo) || (vm.accountInfo.parentAccountId)) {
        return false;
      }
      else if (user.permissions.indexOf("DeliveryLimitWarning") >= 0) {
        return true;
      }
      else {
        return false;
      }
    }

    vm.shouldShowMessageQuotaWarning = function() {

      if (vm.canConfigureMessageQuotaWarning() && vm.totalSentForMonth) {
        return (vm.totalSentForMonth) >= vm.warningThreshold
      }
      else {
        return false
      }
    }

    vm.updatePagingState = function(){
      pagingService.setCurrentPage(vm.campaignsPaged.currentPageNum);
    };
    vm.deleteCampaign = function (campaign) {

      confirmService.confirmWithOptions({
        heading: 'Delete Confirmation',
        message: `Are you sure you want to delete the campaign, "${campaign.name}"?`,
        theme: confirmService.DELETE,
        template: `
        <div class="checkbox">
            <label><input type="checkbox" ng-model="deleteReviews"> Delete all reviews for this campaign?</label>
        </div>`,
        initialModel: { deleteReviews: true }
      })
        .then(( params ) => {
          vm.state.updating = true;
          campaignManagerService.deleteCampaign(campaign, params.deleteReviews || false).then(function () {
            var updateInfo = {
              status: "Active",
              type: "campaign",
              title: "Campaign",
              destinationRole: "manage",
              notificationType: "detail",
              actions: [{action: "delete"}],
              entity: campaign,
              id: campaign._id,
              name: campaign.name,
              searchParam: campaign.name
            };
            updateService.registerSuccessfulUpdate(updateInfo, true);

          }).finally(() => vm.state.updating = false);
        })
    };

    vm.gotoCampaignEditor = function (opType, campaign) {

      if (opType == "create") {
        $state.go('reviewBuilder.campaigns.create')
      } else if (opType == "edit") {
        $state.go('reviewBuilder.campaign.edit', {campaignId: campaign._id.$oid});
      }
    };


    vm.isUpdatedItemRow = function(id,entityId){
      return id==entityId;
    };

    refreshCampaigns();

    function processActivation(response) {
      vm.campaign = response;
      var status = "Active"
      var action = "activate"
      if (!response.isActive) {
        status = "Inactive"
        action = "deactivate"
      }
      var updateInfo = {
        status: status,
        type: "campaign",
        title: "Campaign",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action: action}],
        entity: response,
        id: response._id,
        name: response.name,
      };
      updateService.registerSuccessfulUpdate(updateInfo, true);
    }

    vm.openDeliveryMetricsTimespanModal = function () {
      $('#deliveryMetricsTimespanModal').modal();
    };

    vm.close = function(){
      vm.getNumberOfDeliveryMethods()
      $('#deliveryMetricsTimespanModal').modal('hide');
    }

    vm.getNumberOfDeliveryMethods()

    $scope.$on('campaignDeleted', (event, campaign) => {
      refreshCampaigns();
    });
  });
};
